import { createContext, useState } from 'react';
import api from 'services/api';

export const ProdutosContext = createContext();

export const ProdutosProvider = ({ children }) => {
  const [postLoading, setPostLoading] = useState(false);
  const [getLoading, setGetLoading] = useState(false);

  const getProduto = async ({ id, cb, ...rest }) => {
    try {
      setGetLoading(true);
      const { data } = await api.get(`/Cadastros/Produto/${id}`, {
        params: { ...rest, Midias: true, Descricao: true },
      });
      if (cb) {
        cb(data);
      }
    } catch (error) {
    } finally {
      setGetLoading(false);
    }
  };

  const postProdutos = async ({ data, cb }) => {
    try {
      setPostLoading(true);
      await api.post('/Cadastros/Produto/Produtos', data);
      if (cb) {
        cb();
      }
    } catch (error) {
    } finally {
      setPostLoading(false);
    }
  };

  const postEtiquetas = async ({ data, cb }) => {
    try {
      setPostLoading(true);
      await api.post('/Cadastros/Produto/Etiquetas', data);
      if (cb) {
        cb();
      }
    } catch (error) {
    } finally {
      setPostLoading(false);
    }
  };

  const getProdutoSaldo = async ({ id, cb = null }) => {
    try {
      setGetLoading(true);
      const { data } = await api.get(`/Cadastros/Produto/Saldo/${id}`);
      if (cb) {
        cb(data);
      }
    } catch (error) {
    } finally {
      setGetLoading(false);
    }
  };

  const getProdutoIndicadores = async ({ id, item_id = '', cb = null }) => {
    try {
      setGetLoading(true);
      const { data } = await api.get(
        `/Graficos/CadastrosProdutoIndicadores/${id}/${item_id}`
      );
      if (cb) {
        cb(data);
      }
    } catch (error) {
    } finally {
      setGetLoading(false);
    }
  };

  return (
    <ProdutosContext.Provider
      value={{
        getProduto,
        getLoading,
        postLoading,
        postProdutos,
        postEtiquetas,
        getProdutoSaldo,
        getProdutoIndicadores,
      }}
    >
      {children}
    </ProdutosContext.Provider>
  );
};
